import React from "react";

const ItemTablaNroComercio = ({ dato, darkMode, onEdit }) => {
    return (
        <tr
            className={
                darkMode
                    ? "tabla-borde-bottom text-white"
                    : "tabla-borde-bottom text-dark"
            }
        >
            <td className="fs-12-a-10 lato-regular pt-4">{dato.id}</td>
            <td className="fs-12-a-10 lato-regular pt-4">{dato.nroComercio1}</td>
            <td className="fs-12-a-10 lato-regular pt-4">{dato.nomRubro}</td>
            <td className="fs-12-a-10 lato-regular pt-4">{dato.categoria}</td>
            <td className="fs-12-a-10 lato-regular pt-4">{dato.legajos}</td>
            <td className="fs-12-a-10 lato-regular pt-3">
                <button className="btn btn-sm btn-outline-secondary" onClick={() => onEdit?.(dato)}>
                    Editar
                </button>
            </td>
        </tr>
    );
};

export default ItemTablaNroComercio;
